"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueField = exports.ListField = exports.DateField = void 0;
var _react = _interopRequireDefault(require("react"));
var _Pill = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Pill"));
var _date = require("../../../utils/date");
var styles = {
  "data-table": "data-table_34lm80",
  "dataTable": "data-table_34lm80",
  "custom-fields-toggle": "custom-fields-toggle_3M8QCa",
  "customFieldsToggle": "custom-fields-toggle_3M8QCa",
  "pill": "pill_2WgTHW",
  "pill-span": "pill-span_1ERn7s",
  "pillSpan": "pill-span_1ERn7s"
}; 
require('./CustomFields.css');
var ValueField = exports.ValueField = function ValueField(_ref) {
  var customField = _ref.customField;
  return customField.value || customField.textValue || customField.numberValue;
};
var DateField = exports.DateField = function DateField(_ref2) {
  var customField = _ref2.customField;
  return (0, _date.formatDate)(customField.value || customField.dateValue);
};
var ListField = exports.ListField = function ListField(_ref3) {
  var customField = _ref3.customField;
  return (customField.value || customField.textListValue || customField.numberListValue || customField.enumValue).map(function (value, index) {
    return /*#__PURE__*/_react.default.createElement(_Pill.default, {
      key: index,
      className: styles.pill,
      disabled: true,
      title: value
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: styles.pillSpan
    }, value));
  });
};
//# sourceMappingURL=Fields.js.map